export const HBAK = "9d5d98e72929dae3c8b3701f50032da1a02b80f9dc29a8e448a601871e5c82fd0ac2fa33c46443709cdb3eabc54a06ab";
export const SECRET_KEY = "G]4}QTx&*`_r?j7tF=dmgquHw,EYL@6p>;$X~^'/9cWyV<#25P";
export const SALT = "66f5d06fd59f2d164c2639ddc7ef7e2f";
export const INITIAL_VECTOR = "000b86656443f66ed0ef4aac828457d3";
export const HONEYBADGER_IGNORED_STATUS_CODES = [426, 403, 404, 422];
export const HONEYBADGER_IGNORED_ERROR_MESSAGES = [
    "Run was stopped",
    "Attempt was already reported",
    "Request failed with status code 524",
    "Run with same CI build id already exists",
    "Project was archived. Unarchive the project to start reporting",
    "Ci build has already been taken",
    "Could not authenticate, invalid API Key",
];
export const INVALID_PROJECT_KEY_ERROR = "Project does not exist.";
export const INVALID_API_KEY_ERROR = "Could not authenticate, invalid API Key";
export const DEFAULT_API_KEY_VALUE = "api-key";
export const DUPLICATE_CI_BUILD_ID_ERROR = "Run with same CI build id already exists";
export const RUN_WAS_STOPPED_ERROR = "Run was stopped";
//# sourceMappingURL=common.js.map